module.exports = __webpack_public_path__ + "img/safe_icon.ed7e302b.png";